import Template from "../templates/HealthcareProviderExcerptOverview/HealthcareProviderExcerptOverview";

const HealthcareProviderDataSummaryOverview = () => <Template />;

export default HealthcareProviderDataSummaryOverview;
